import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white create-role-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Role Name ", -1)
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Role Description ", -1)
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Is System Admin?  ", -1)
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Create Role ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createRole && _ctx.createRole(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleName) = $event)),
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Administrator",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.roleName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.roleDescription) = $event)),
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Administrator",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.roleDescription]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input shadow-none",
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isSystemAdmin) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.isSystemAdmin]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToMainMenu && _ctx.goToMainMenu(...args))),
              class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 m-5 bg-danger",
              type: "button"
            }, " Cancel ")
          ])
        ])
      ], 32)
    ])
  ]))
}